<template>
  <div>
    <nf></nf>
  </div>
</template>
<script>
  import Notification from '@/components/chat/Notification'
  export default {
    data() {
      return {

      };
    },
    components:{
      'nf':Notification
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/chat/Chat.vue